import { ArrowRightLeft, CheckCircle, ClipboardCheck, Eye, KeyRound, Pencil, Trash2 } from "lucide-react";

/**
 * Always-visible row actions (View is never hidden behind hover).
 * Matches admin tenant table UX with clear cyan View affordance.
 */
export default function RowActionBar({
  testId,
  rowId,
  view = true,
  modify = false,
  delete: canDelete = false,
  review = false,
  approve = false,
  access = false,
  move = false,
  onView,
  onModify,
  onDelete,
  onReview,
  onApprove,
  onAccess,
  onMove,
  readOnly = false,
  extraActions = [],
}) {
  const id = rowId != null ? String(rowId) : "row";
  const base = testId || "row";
  const hasStandard = view || modify || canDelete || review || approve || access || move;

  return (
    <div className="row-action-bar" data-testid={testId || `row-actions-${id}`}>
      {view && (
        <button
          type="button"
          className="row-action-btn row-action-view"
          data-testid={`${base}-view-${id}`}
          onClick={onView}
          title="View details"
        >
          <Eye size={14} /> View
        </button>
      )}
      {review && (
        <button
          type="button"
          className="row-action-btn row-action-review"
          data-testid={`${base}-review-${id}`}
          onClick={onReview}
          title="Review record"
        >
          <ClipboardCheck size={14} /> Review
        </button>
      )}
      {approve && (
        <button
          type="button"
          className="row-action-btn row-action-approve"
          data-testid={`${base}-approve-${id}`}
          onClick={onApprove}
          title="Approve change"
        >
          <CheckCircle size={14} /> Approve
        </button>
      )}
      {access && (
        <button
          type="button"
          className="row-action-btn row-action-access"
          data-testid={`${base}-access-${id}`}
          onClick={onAccess}
          title="Edit access & authority"
        >
          <KeyRound size={14} /> Access
        </button>
      )}
      {move && (
        <button
          type="button"
          className="row-action-btn row-action-move"
          data-testid={`${base}-move-${id}`}
          onClick={onMove}
          title="Move to another program"
        >
          <ArrowRightLeft size={14} /> Move
        </button>
      )}
      {modify && (
        <button
          type="button"
          className="row-action-btn row-action-modify"
          data-testid={`${base}-edit-${id}`}
          onClick={onModify}
          title="Modify"
        >
          <Pencil size={14} /> Modify
        </button>
      )}
      {canDelete && (
        <button
          type="button"
          className="row-action-btn row-action-delete"
          data-testid={`${base}-delete-${id}`}
          onClick={onDelete}
          title="Delete"
        >
          <Trash2 size={14} /> Delete
        </button>
      )}
      {extraActions.map((action) => (
        <button
          key={action.id}
          type="button"
          className={`row-action-btn ${action.className || ""}`}
          data-testid={action.testId || `${base}-${action.id}-${id}`}
          onClick={() => action.onClick?.()}
          title={action.title || action.label}
          disabled={action.disabled}
        >
          {action.icon}{action.label}
        </button>
      ))}
      {readOnly && !hasStandard && !extraActions.length && (
        <span className="row-action-readonly muted small-note">Read-only</span>
      )}
    </div>
  );
}
